import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    loginAuth(formdata) {
        return API.post('authenticate', httpBuildQuery(formdata))
        .then((response) => {
            let retval = false;
            if (response) {
                retval = response.data;
            }
            return retval;
        }).catch((error) => {
            console.log(error);
        });
    },
};
